<div class="nofondPage unity-padding-web unity-padding-h5-12">
  <div class="nofondPage-content">
    <div class="nofondPage-content-top">
      <img src="assets/images/nofondpage.jpg" alt="" />
    </div>
    <div class="nofondPage-content-bottom">
      <span class="tips">{{ 'oops' | translate }}</span>
      <span class="text">{{ 'you_got_a_404_that_means_this_page_doesn_t' | translate }}</span>
      <cs-button [label]="'back_to_home' | translate" width="auto" (buttonClick)="goHome()"></cs-button>
    </div>
  </div>
</div>
